import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'

export const useSelectedClinicId = () => {
  const config = useConfig()
  const { selectedBookableDateAndTime } = useChoiceState()
  const clinicId = selectedBookableDateAndTime.clinicId || config.clinicId

  return clinicId
}
